import { useStrictLocalization } from "@faire/web--source/common/localization";

export const useLevelNodesSectionTitles = () => {
  const { strictLocalize } = useStrictLocalization();

  return {
    selectIssueType: strictLocalize({
      defaultMessage: "Select an issue type",
    }),
    whatIssue: strictLocalize({
      defaultMessage: "What's the issue with this order?",
    }),
    whatIssueWithoutOrder: strictLocalize({
      defaultMessage: "What's the issue?",
    }),
    chooseCategory: strictLocalize({
      defaultMessage: "Choose a category",
    }),
    chooseType: strictLocalize({
      defaultMessage: "Choose a type",
    }),
    chooseSubType: strictLocalize({
      defaultMessage: "Choose a sub-type",
    }),
  };
};
